import { render } from "./CodemirrorEditor.vue?vue&type=template&id=0ce33e88"
import script from "./CodemirrorEditor.vue?vue&type=script&lang=js"
export * from "./CodemirrorEditor.vue?vue&type=script&lang=js"

import "./CodemirrorEditor.vue?vue&type=style&index=0&id=0ce33e88&lang=css"
import "./CodemirrorEditor.vue?vue&type=style&index=1&id=0ce33e88&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__